import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { FuncionesService } from 'src/app/services/funciones.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/services/http/request.service';
import { currentIp } from 'src/app/_helpers/utils/funciones.utils';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginSsoService {
  headersWalmart = new HttpHeaders()
  .set('Authorization', environment.http.auth.sso.tokenSSO)
  .set('Content-Type', 'application/x-www-form-urlencoded')
  constructor(
    private req: RequestService,
    private httpSrv: HttpClient
  ) {}

  generartokenSSO(token : string) :Observable<any> {
    return this.req.get(environment.http.auth.sso.api.generarSesionSSO.replace('{code}', token), '',
    {
      ordServicio: environment.apiKeys.ordServicio
    })
  }

  generarTokenEndpoint(code : string) : Observable<any> {
    const payload = new HttpParams({
      fromObject:  {
        redirect_uri  : `${currentIp()}/sso`,
        grant_type    : 'authorization_code',
        code,
        client_id     : environment.http.auth.sso.clientId,
        code_verifier : environment.http.auth.sso.codeVerifier
      }
    })
    return this.httpSrv.post(`${environment.http.auth.sso.serverWalmart}${environment.http.auth.sso.api.generarTokenEndpoint}`,
    payload.toString(),
    { 
      headers: this.headersWalmart
    })
  }
  
  saveToken(token : string, correo: string) : Observable<any> {
    return this.req.post(environment.http.auth.sso.api.saveToken,
      {
        token,
        correo
      },
      {
        ordServicio: environment.apiKeys.ordServicio
      }
    )
  }

  introspectionEmail(token : string) : Observable<any> {
    const  headersWalmart = new HttpHeaders()
    .set('Authorization', `Bearer ${token}`)
    .set('Content-Type', 'application/x-www-form-urlencoded')

    return this.httpSrv.get(
      `${environment.http.auth.sso.serverWalmart}${environment.http.auth.sso.api.userInfo}`,
      {
        headers: headersWalmart
      }
    )
  }

  revocationEndPoint(refreshToken : string) : Observable<any> {
    const payload = new HttpParams({
      fromObject:  {
        token: refreshToken,
        token_type_hint: 'refresh_token'
      }
    })
    return this.httpSrv.post(
      `${environment.http.auth.sso.serverWalmart}${environment.http.auth.sso.api.revocationEndPoint}`,
      payload.toString(),
      {
        headers: this.headersWalmart
      }
    )

  }
}
